import { MultiValue } from "react-select";
import { BinInfo } from "../staticInfo/state";

export type InitialRouteDetailItem = {
    cleaning_detail_route_id: number;
    sequence: number;
    time_start: string | null;
    time_end: string | null;
    value: number;
    label: string;
};

export type CleaningRouteState = {
    cleaningRouteList: CleaningRouteList[] | [];
    selectedDetailRouteList: MultiValue<BinInfo> | null;
    initialRouteDetails: InitialRouteDetailItem[] | null;
    route_name: string | null;
    effective_date: moment.Moment | Date | null | string;
    weekday: number | null | string;
    mon: number;
    tue: number;
    wed: number;
    thu: number;
    fri: number;
    sat: number;
    sun: number;
    holiday: number | null;
    cleaner_id: string | null;
    remark: string | null;
    route_cleaning_id: number | null;
};

export type CleaningRouteList = {
    route_cleaning_id: number;
    route_name: string;
    effective_date: moment.Moment | Date | null | string;
    create_date: string;
    weekday: number | string;
    mon?: number;
    tue?: number;
    wed?: number;
    thu?: number;
    fri?: number;
    sat?: number;
    sun?: number;
    holiday?: number;
    username: string;
    user_id: string | null;
    remark: string | null;
};

export const cleaningRouteState: CleaningRouteState = {
    cleaningRouteList: [],
    selectedDetailRouteList: null,
    initialRouteDetails: null,
    route_name: null,
    effective_date: null,
    weekday: null,
    mon: 0,
    tue: 0,
    wed: 0,
    thu: 0,
    fri: 0,
    sat: 0,
    sun: 0,
    holiday: null,
    cleaner_id: null,
    remark: null,
    route_cleaning_id: null,
};